import { type ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeEsCO from '@angular/common/locales/es-CO';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import {
  AUTH_API_URL,
  authInterceptor,
  provideLoginFlowMessages,
  provideLoginRoutePolicy,
} from '@my-sport-app/domain';

registerLocaleData(localeEsCO);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideAnimations(),
    { provide: LOCALE_ID, useValue: 'es-CO' },
    { provide: AUTH_API_URL, useValue: environment.apiUrl },
    provideLoginRoutePolicy({
      loginRoute: '/auth/login',
      businessOwnerRoute: '/business-owner-dashboard',
      defaultRoute: '/home',
      accessDeniedRoute: '/unauthorized',
    }),
    provideLoginFlowMessages({
      businessOwnerAccessDenied: 'Tu cuenta no tiene permisos para acceder a esta seccion.',
    }),
  ]
};